

export const storeLogin = (lang: string) => {
    localStorage.clear();
    localStorage.setItem('lang', lang);
    localStorage.setItem('logedInPisaMath', 'true');
}

export const handleDefaultSignin = (lang: string) => {
    storeLogin(lang);
    window.location.assign(`https://www.yisumatica.org.il/idm_login`);
}


export const badCredentialsAlert = (str: string) => {
    if (localStorage.getItem('PisaMathBadCredentials')) {
       alert(str);
       localStorage.clear();
    }
}

export const cleanLocalStorage = () => {
    if (localStorage.getItem('logedInAlMada')) {
        localStorage.removeItem('logedInAlMada')
    }
    if (localStorage.getItem('logedInQuizForm')) {
        localStorage.removeItem('logedInQuizForm')
    }
    if (localStorage.getItem('logedInExcellence2000')) {
        localStorage.removeItem('logedInExcellence2000')
    }
    
}
